module.exports = __webpack_public_path__ + "media/conmex/herramientas-c2e4729d.png";